import { analyticsIdentify, analyticsTrack } from '../application/javascripts/analytics_util';
import { SubscribeUserResponse } from './backend-api/subscribe';

const SUBSCRIPTION_CONVERSION_EVENT_NAME = 'Subscription Conversion';

// This function allows us to pass a tracking properties object like {key: value}, and it
// converts the keys to "data-key" so that it can be used as a data attribute for tracking
export const generateTrackingAttributes = (data: { [key: string]: string }) => {
  const trackingProps = {};
  for (const [key, value] of Object.entries(data)) {
    trackingProps[`data-${key}`] = value;
  }
  return trackingProps;
};

export const legacyTracking = (response: SubscribeUserResponse) => {
  const {
    affiliation,
    email,
    initialSubscriptionPrice,
    offerCode,
    productSku,
    redirectTo,
    stripePlanName,
    subscriptionVariant,
    trackConversion,
    userId,
  } = response;
  if (trackConversion) {
    window.createAhoyEvent(email);
    analyticsIdentify(userId.toString(), { call_location: 'tracking.ts' });
    analyticsTrack(SUBSCRIPTION_CONVERSION_EVENT_NAME, {
      value: initialSubscriptionPrice,
    });

    window['optimizely'] = window['optimizely'] || [];
    window['optimizely'].push({
      type: 'event',
      eventName: 'subscription',
      tags: {
        revenue: parseInt(initialSubscriptionPrice) * 100,
      },
    });

    const gtagObject = {
      affiliation: affiliation,
      currency: 'USD',
      items: [
        {
          brand: 'The Information', // TODO: Set enum: "The Information", "NEWSLETTER_NAME"
          category: 'Subscriptions', // TODO: Set enum: "Subscriptions" | "Newsletters" | "Events"
          coupon: offerCode,
          id: productSku, // Aligns with GA SKU
          name: stripePlanName, // Aligns with GA Product Name
          price: initialSubscriptionPrice,
          quantity: 1,
          variant: subscriptionVariant,
        },
      ],
      transaction_id: `${userId}_${Date.now()}`,
      value: parseInt(initialSubscriptionPrice),
    };
    gtag('event', 'purchase', gtagObject);
  }

  window.location.href = redirectTo;
};
